
/* injects from baggage-loader */

const moduleSlider = angular.module('slider.initializer', []);

moduleSlider.service('Slider', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) => {
    'use strict';
    let Y;

    const slider = {
      init: function(y) {
        Y = y;

        this.initSliders();
      },
      resizers: [],

      findSliders: function() {
        var layoutEditor;
        layoutEditor = $injector.get("layoutEditor");
        this.sliders = $(".str-block ." + ns.sliderClass);
      },
      initSlider: function(index, slider, onSlideChangeStart) {

        if (onSlideChangeStart == null) {
          onSlideChangeStart = false;
        }

        let optionsJson = $(slider).data("slider-settings");

        const defaultOptions = {
          pagination: $(slider).find('.swiper-pagination'),
          paginationClickable: $(slider).find('.swiper-pagination'),
          nextButton: $(slider).find('.swiper-button-next'),
          prevButton: $(slider).find('.swiper-button-prev'),
          simulateTouch: false,
          onSlideChangeStart: onSlideChangeStart
        };

        optionsJson = _.extend(optionsJson, defaultOptions);
        if ($(slider)[0] && $(slider)[0].swiper) {
          $(slider)[0].swiper.destroy(true, true);
        }

        let newSwiperTop = new Swiper($(slider), optionsJson);
        let newSwiperThumbs;

        if (optionsJson.thumbs) {
          const thumbsContainer = $(slider).parent().find(".gallery-thumbs")[0];
          if (thumbsContainer.swiper) {
            thumbsContainer.swiper.destroy(true, true);
          }

          const thumbsOptions = {
            centeredSlides: true,
            slidesPerView: 'auto',
            touchRatio: 0.2,
            slideToClickedSlide: true
          };

          newSwiperThumbs = new Swiper(thumbsContainer, thumbsOptions);
          newSwiperTop.params.control = newSwiperThumbs;
          newSwiperThumbs.params.control = newSwiperTop;
        }

        return [newSwiperTop, newSwiperThumbs];
      },
      initSliders: function() {
        this.findSliders();
        this.sliders.each(this.initSlider);
      },

      updateSlider: function(slider) {
        if ($(slider._node)[0].swiper) {
          const swiper = $(slider._node)[0].swiper;

          if (swiper.activeIndex !== 0) {
            swiper.slideTo(0, 0);
          }

          swiper.update();
        }
      },
      updateSliders: function() {
        Y.all("." + ns.sliderClass).each(this.updateSlider);
      },
      destroy: function() {}
    };

    return slider;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/slider/slider.initializer.js